import { render, staticRenderFns } from "./App.vue?vue&type=template&id=9087fe26"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9087fe26')) {
      api.createRecord('9087fe26', component.options)
    } else {
      api.reload('9087fe26', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=9087fe26", function () {
      api.rerender('9087fe26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/App.vue"
export default component.exports